import React, { PropTypes } from 'react';
import classNames from 'classnames';


const NAdmin = () => (
    <div className="card tacCards">
        <div className="card-header">
            <span> <svg className="cyclops-icon" aria-hidden="true"><use xlinkHref='#icon-minus-circle' /> </svg> Administrator Action Needed </span>
        </div>
        <div className="card-block">
            <h5>Thank you for your interest in gaining access to integrated Azure. An administrator of your account has the ability to provide access to you. Please visit this <a href="https://www.ctl.io/knowledge-base/accounts-&-users/user-permissions/" target="_blank">article</a> to learn how to locate your administrator.</h5>
        </div>
    </div>
);

export default NAdmin;


/** WEBPACK FOOTER **
 ** ./src/components/Tac/NAdmin.js
 **/